import { baseAPIInstance } from '../instanse';

export const uploadChunkAsync = (data: FormData) =>
    baseAPIInstance.post(`/video/upload-chunk`, data);
